var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner",class:_vm.type},[_c('div',{staticClass:"bottom"},[_c('div',{staticClass:"tips"},[_vm._v(_vm._s(_vm.headObj.title))]),_c('div',{staticClass:"info"},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.headObj.desc))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }